module.exports = __webpack_public_path__ + "static/4-6e30e5acc4e6f63504ea343236980c36.mp4";